import { drawJersey } from '@/common/assets';
import { PlatformSection } from '@/common/components';
import { useNewTranslations } from '@/common/translations';
import { StatsPreviousMeetings } from '../../components';
import { usePrematchData } from '../../hooks';

export default function PreviousMeetingsSection() {
  const translate = useNewTranslations();
  const { teams, statistics } = usePrematchData();
  const sectionName = translate('PreMatchStats.PreviousMeetings');

  if (!statistics?.previousMeetings) {
    return null;
  }

  const { homeWins, draws, awayWins } = statistics.previousMeetings;

  return (
    <PlatformSection name={sectionName} contentClassName="py-0">
      <StatsPreviousMeetings
        homeWins={homeWins}
        draws={draws}
        awayWins={awayWins}
        homeJerseySrc={teams.home.jersey}
        drawJerseySrc={drawJersey}
        awayJerseySrc={teams.away.jersey}
      />
    </PlatformSection>
  );
}
